import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\">\n    <title>形状结合</title>\n    <g id=\"icon-close_页面-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\">\n        <path d=\"M1.5,1.5 L31.5,31.5 M31.5,1.5 L1.5,31.5\" id=\"icon-close_形状结合\" stroke=\"#848484\" stroke-width=\"2\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol